// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'polyfill-array-includes';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import vuetify from 'vuetify';
import ifvisible from 'ifvisible.js';
import axios from 'axios';
import url from '../config/root-url';

import 'material-design-icons/iconfont/material-icons.css';
import './assets/roboto/roboto.css';


Vue.use(vuetify);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el         : '#app',
  router,
  template   : '<App/>',
  components : { App },
  store,
});

window.addEventListener(`load`, () => {
  const updateOnlineStatus = () => {
    store.dispatch(`changeOnlineStatus`, navigator.onLine);
  };

  window.addEventListener(`online`,  updateOnlineStatus);
  window.addEventListener(`offline`, updateOnlineStatus);

  ifvisible.on(`wakeup`, () => {
    store.dispatch(`triggerUpdate`);
  });
});

window.setInterval(() => {
  store.dispatch(`updateServiceWorker`, true);
}, 1000 * 60 * 60 * 6);// every 6 hours



// WEBPACK FOOTER //
// ./src/main.js